import React, { Component } from 'react';
import Grid from '@react/react-spectrum/Grid/js/Grid';
import GridColumn from '@react/react-spectrum/Grid/js/GridColumn';
import GridRow from '@react/react-spectrum/Grid/js/GridRow';
import { Translate } from 'react-redux-i18n';
import Button from '@react/react-spectrum/Button';
import { CONTACT_HELPDESK } from '../../../config/constants';

class SubmittedInReview extends Component {

    render() {
        return <div>
            <Grid>
                <GridRow>
                    <GridColumn size={[12, 8, 6, 6]} offsetSize={[0, 2, 3, 3]}>
                        <GridRow className="padding-3 font">
                            <GridColumn >
                                <span>Thank you for your interest in the {this.props.formName} specialization. We are already reviewing a previously submitted application. We will notify you via email of any updates regarding your application. 
                                If you need assistance, please contact the Adobe Partner Connection Help Desk.</span>
                            </GridColumn>
                        </GridRow>
                        <GridRow>
                            <GridColumn>
                                <Button variant="primary" onClick={() => {
                                    window.open(CONTACT_HELPDESK, "_blank");
                                }
                                }>Contact Helpdesk</Button>
                            </GridColumn>
                        </GridRow>
                    </GridColumn>
                </GridRow>
            </Grid>
        </div>
    }
}

export default SubmittedInReview;